import { Action } from 'redux';

import { AppState } from '~src/bootstrap/redux/state/AppState';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { isAdminProfileSitesSpace } from '~src/spacesPlatform/state/SpaceInfo';

export const ADMIN_PROFILE_REMOVE_FROM_SITE = 'ADMIN_PROFILE_REMOVE_FROM_SITE';

export interface AdminProfileRemoveFromSiteActionPayload extends Action {
  type: typeof ADMIN_PROFILE_REMOVE_FROM_SITE;
  profileId: string;
  siteIds: string[];
}

export function adminProfileRemoveFromSite(profileId: string, siteIds: string[]): AdminProfileRemoveFromSiteActionPayload {
  return {
    type: ADMIN_PROFILE_REMOVE_FROM_SITE,
    profileId,
    siteIds,
  };
}

/**
 * Removes the admin profile from the selected site(s). Only visible in Admin Profile Sites tab.
 * Shows a confirmation dialog and calls updateAdminProfileSites with the remaining sites on confirm.
 */
export const AdminProfileRemoveFromSiteAction: IEntityAction<IContentInfo<'site'>, {}> = {
  name: EntityActionNames.AdminProfileRemoveFromSite,
  translateName: Messages.adminProfileSiteRemoveFromSite,
  isVisible: (_targetItems: IContentInfo<'site'>[], state: AppState) => {
    return isAdminProfileSitesSpace(state.spaceInfo);
  },
  isClickable: (_availableActions: {}, targetItems: IContentInfo<'site'>[]) => {
    return targetItems.length > 0;
  },
  createReduxAction: (targetItems: IContentInfo<'site'>[]) => {
    const state = getAppStore().getState();
    const spaceInfo = selectSpaceInfo(state);
    const profileId = spaceInfo?.item?.id ?? '';
    const siteIds = targetItems.map(item => item.id);
    return adminProfileRemoveFromSite(profileId, siteIds);
  },
};
